<template>
  <div class="share">
    <span>Поделиться</span>
    <div class="share_buttons">
      <a @click.prevent="vk(url, title, img, description)" href="#" class="share_buttons_button vk">
        <font-awesome-icon :icon="['fab', 'vk']" />
      </a>
      <!--      <a @click.prevent="facebook(url, title, img, description)" href="#" class="share_buttons_button fb">
        <font-awesome-icon :icon="['fab', 'facebook']" />
      </a>-->
      <a @click.prevent="ok(url, description)" href="#" class="share_buttons_button ok">
        <font-awesome-icon :icon="['fab', 'odnoklassniki']" />
      </a>
      <!--      <a @click.prevent="twitter(url, title)" href="#" class="share_buttons_button tw">
        <font-awesome-icon :icon="['fab', 'twitter']" />
      </a>-->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    url: String,
    title: String,
    img: String,
    description: String,
  },
  methods: {
    vk (purl, ptitle, pimg, text) {
      let url = 'https://vk.com/share.php?'
      url += 'url=' + encodeURIComponent(purl)
      url += '&title=' + encodeURIComponent(ptitle)
      url += '&description=' + encodeURIComponent(text)
      url += '&image=' + encodeURIComponent(pimg)
      url += '&noparse=true'
      this.popup(url)
    },
    facebook (purl, ptitle, pimg, text) {
      let url = 'http://www.facebook.com/sharer.php?s=100'
      url += '&p[title]=' + encodeURIComponent(ptitle)
      url += '&p[summary]=' + encodeURIComponent(text)
      url += '&p[url]=' + encodeURIComponent(purl)
      url += '&p[images][0]=' + encodeURIComponent(pimg)
      this.popup(url)
    },
    ok (purl, text) {
      let url = 'http://ok.ru/dk?st.cmd=addShare&st.s=1'
      url += '&st.comments=' + encodeURIComponent(text)
      url += '&st._surl=' + encodeURIComponent(purl)
      this.popup(url)
    },
    twitter (purl, ptitle) {
      let url = 'http://twitter.com/share?'
      url += 'text=' + encodeURIComponent(ptitle)
      url += '&url=' + encodeURIComponent(purl)
      url += '&counturl=' + encodeURIComponent(purl)
      this.popup(url)
    },
    popup (url) {
      window.open(url, '', 'toolbar=0,status=0,width=626,height=436')
    },
  },
}
</script>

<style lang="less">
.share {
	display: flex;
	flex-direction: column;
	align-items: center;

	& > span {
		font-family: 'Roboto', Arial, sans-serif;
		font-weight: 300;
		font-size: 14px;
		text-align: center;
		margin-bottom: 11px;
	}

	&_buttons {
		max-width: 100%;
		height: 46px;
		display: flex;
		align-items: center;
		background-color: #F9F9F9;
		padding: 0 25px;
		border-radius: 23px;

		&_button {
			&:not(:last-child) { margin-right: 52px; }

			&.vk {
				font-size: 16px;
				color: #2787F5;
			}

			&.fb {
				font-size: 25px;
				color: #4267B2;
			}

			&.ok {
				font-size: 26px;
				color: #F96500;
			}

			&.tw {
				font-size: 21px;
				color: #33BDF1;
			}
		}
	}
}
</style>
